export const GET_USER_PROFILE = "auth/GET_USER_PROFILE";
export const GET_USER_PROFILE_RESULT = "auth/GET_USER_PROFILE_RESULT";
export const LOGOUT = "auth/LOGOUT";